<template>
  <div>
    <myheader></myheader>
    <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">{{ info.title }}</h1>
    <div class="affiche_time">
      发布时间：{{ info.created_at }} 来源：{{ info.source }}
    </div>
    <div v-html="info.content" class="about_content">
    </div>
    <myfooter></myfooter>
  </div>
</template>

<script>
import {Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem} from 'vant'
import { getNewsInfo } from '@/api'
export default {
  name: 'NewsInfo',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
  },
  data() {
    return {
      info: {
        id: '',
        title: '',
        content: '',
        description: '',
        source: '',
        created_at: '',
      }
    }
  },
  methods: {
    getInfo(){
      getNewsInfo(this.info.id).then(res => {
        Object.assign(this.info, res.data)
      })
    }
  },
  mounted() {
    this.info.id = this.$route.params.id
    this.getInfo()
  }
}
</script>

<style scoped>
  .about_content {
    padding: 1rem 1.5rem 2.1rem;
    font-size: 0.78rem;
    font-weight: normal;
    color: #666666;
    line-height: 1.2rem;
  }
  .affiche_time {
    font-size: .84rem;
    color: #999999;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
  }
</style>
